import { CalendarCheck, MapPin, Search, ShoppingBag, Store } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Channel logo in a rounded white tile.
 *
 * External-app channels (Google, Meta, Deliveroo…) carry a real brand logo on
 * their channel definition. Unify's own channels — Storefront, Reservations,
 * Local Checkout — all share the generic nearst logo, which is ambiguous, so
 * each is given a distinct lucide glyph instead.
 *
 * The definition icons are full-bleed logos (some are wordmarks, e.g. Uber
 * Eats); rounding the image itself clips the artwork, so it's inset in a
 * padded tile. `className` sizes the tile (e.g. `h-11 w-11`).
 */
const ICON_OVERRIDES = {
	storefront: Store,
	'product-reservations': CalendarCheck,
	'local-checkout': ShoppingBag,
	'search-widget': Search,
	'product-locator': MapPin
};

export function ChannelIcon({ channelId, src, className }) {
	const Override = ICON_OVERRIDES[channelId];
	if (Override) {
		// Unify's own channels get a brand-gradient tile with a white glyph.
		return (
			<span className={cn('flex shrink-0 items-center justify-center rounded-xl bg-gradient-unify p-1.5 shadow-sm', className)}>
				<Override className="h-6 w-6 text-white" strokeWidth={1.75} />
			</span>
		);
	}
	return (
		<span className={cn('flex shrink-0 items-center justify-center rounded-xl border border-border/60 bg-white p-1.5', className)}>
			<img src={src} alt="" className="h-full w-full object-contain" />
		</span>
	);
}
